import styled, { css } from 'styled-components';

export const StyledIcon = styled.div`
  display: inline-flex;
  align-items: center;
  svg {
    margin-right: 10px;
    border-radius: 5px;
    ${({ theme }) =>
      theme.isDark &&
      css`
        filter: invert(1);
      `}
  }
`;
